export default __webpack_public_path__ + "static/media/background-new-scholarship.446bbf07.png";